package one.healthium.profile.ui.update_weight

import kotlin.time.Instant

internal data class UpdateWeightUiState(
    val loading: Boolean = false,
    val originalWeight: Float? = null,
    val originalWeightDate: Instant? = null,
    val currentWeight: Float = 0f,
    val isMetric: Boolean = false,
)
